/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { MktuClassWordsCount } from './MktuClassWordsCount'
import {
  MktuClassWordsCountFromJSON,
  MktuClassWordsCountFromJSONTyped,
  MktuClassWordsCountToJSON,
} from './MktuClassWordsCount'

/**
 * Класс МКТУ
 * @export
 * @interface MktuClass
 */
export interface MktuClass {
  /**
   * UUID класса
   * @type {string}
   * @memberof MktuClass
   */
  uuid: string
  /**
   * Номер класса МКТУ
   * @type {number}
   * @memberof MktuClass
   */
  classNumber: number
  /**
   * Описание класса
   * @type {string}
   * @memberof MktuClass
   */
  classDescription: string
  /**
   * Пояснение к классу
   * @type {string}
   * @memberof MktuClass
   */
  explanation: string | null
  /**
   * Что входит в класс
   * @type {string}
   * @memberof MktuClass
   */
  included: string | null
  /**
   * Что не входит в класс
   * @type {string}
   * @memberof MktuClass
   */
  excluded: string | null
  /**
   *
   * @type {MktuClassWordsCount}
   * @memberof MktuClass
   */
  wordsCount: MktuClassWordsCount
}

/**
 * Check if a given object implements the MktuClass interface.
 */
export function instanceOfMktuClass(value: object): value is MktuClass {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('classNumber' in value) || value['classNumber'] === undefined)
    return false
  if (!('classDescription' in value) || value['classDescription'] === undefined)
    return false
  if (!('explanation' in value) || value['explanation'] === undefined)
    return false
  if (!('included' in value) || value['included'] === undefined) return false
  if (!('excluded' in value) || value['excluded'] === undefined) return false
  if (!('wordsCount' in value) || value['wordsCount'] === undefined)
    return false
  return true
}

export function MktuClassFromJSON(json: any): MktuClass {
  return MktuClassFromJSONTyped(json, false)
}

export function MktuClassFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MktuClass {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    classNumber: json['classNumber'],
    classDescription: json['classDescription'],
    explanation: json['explanation'],
    included: json['included'],
    excluded: json['excluded'],
    wordsCount: MktuClassWordsCountFromJSON(json['wordsCount']),
  }
}

export function MktuClassToJSON(value?: MktuClass | null): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    classNumber: value['classNumber'],
    classDescription: value['classDescription'],
    explanation: value['explanation'],
    included: value['included'],
    excluded: value['excluded'],
    wordsCount: MktuClassWordsCountToJSON(value['wordsCount']),
  }
}
